
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's00a84204340a1db4': `Ausgewählt`,
's01d32b35baa3b676': `Autor(in)`,
's03aa3cfb08dff960': `Tags`,
's086c07fb6264f4da': `Empfohlenes Niveau`,
's15e3f3d39412fc36': str`${0} hat das Kapitel ${1} veröffentlicht.`,
's2d38833d0abf32ef': `Sie müssen mindestens einen Tag vergeben`,
's2fad48135acb1e38': `Aus meinen Materialien entfernen`,
's33f85f24c0f5f008': `Speichern`,
's3f27c55a0bfa1c80': `Skript erstellen`,
's47555d370f2d2997': `Jedermann kann das Skript lesen.`,
's4e228c632bb990fc': `Studierende mit fortgeschrittenen Kenntnissen`,
's4fd4ec4e93f4796e': `PDF erneut erzeugen`,
's53cb475bc0b46bac': `PDF erzeugen`,
's5be3c6d61cd9182f': `Benachrichtigungen`,
's5d929ff1619ac0c9': `Suche`,
's63d894b1ddb06289': `Beschreibung`,
's668c684eba5f8e9c': `Examenskandidat`,
's76f264c139b0e396': `PDF-Generierung fehlgeschlagen. Bitte laden Sie die Seite erneut und versuchen Sie es noch einmal. Falls das den Fehler nicht behebt, wenden Sie sich bitte an den Support.`,
's779dbd42cd9c60f5': `Rechtsgebiet`,
's83047583b71190c2': `Kein Bild ausgewählt. Sie können unten nach Schlüsselworten suchen`,
's91abbda8f446a00c': `Sie müssen einen Titel eingeben`,
's98b1cb8fb62909ec': `Gruppe`,
's991a1d859badc813': `PDF wird generiert...`,
's99f110d27e30b289': `Titel`,
's9ae3ff84f2b87d2b': `PDF herunterladen`,
's9c1323b8121a89fe': `Studierende am Beginn des Studiums`,
's9db9d998030533cd': `Materialien löschen`,
'sa20e3a7765b13dd8': `Bitte wählen Sie das von Ihnen empfohlene Niveau für diese Materialien aus`,
'sa48f81f001b893d2': `Nutzer`,
'sa5558c65b824d700': str`${0} hat dich als Co-Editor zu ${1} hinzugefügt.`,
'sa5634073ce694ac0': `Ihre Materialien sind verfügbar unter `,
'sab8b4cbbb1fa71fa': `Aktuell`,
'sad0216e6a156f353': `Die nachstehenden autorisierten Nutzer und Gruppen können das Skript lesen.`,
'sad3a2d2a8a492607': `Anfänger`,
'sb2d84d0b3f1fb0f5': `Studierende im universitären Schwerpunkt`,
'sb39c29728a3aab64': `Fortgeschrittene`,
'sb3b2c8d59ebc3a0f': str`${0} hat ein Skript mit dem Titel ${1} veröffentlicht.`,
'sb9ebdd08bb1dbe7c': `Bild entfernen`,
'sba5a16f7420a281f': str`${0} hat das Skript ${1} veröffentlicht.`,
'sc24f380ead7a507c': `Sie benutzen diesen Titel bereits für andere Materialien. Bitte wählen sie einen anderen Titel.`,
'sc5fe0486baaf682a': `Zu meinen Materialien hinzufügen`,
'sc80b3241d9d08337': `Studierende in der Examensvorbereitung`,
'sd772a26a19e34e05': `Nur Sie und Ihre Co-Editoren können das Skript lesen.`,
'sdd1ff479d04ac140': `Öffentlich`,
'sdd2c2a02089a57a2': `Schwerpunkt`,
'sde163203e0099c64': `Nach Bildern suchen`,
'se00c4fe4920e141a': str`${0} hat in einem Diskussionsthread geantwortet.`,
'se321f731d4a079aa': `Tags helfen Studierenden dabei, die Materialien in ihrer Bibliothek zu finden. Sie können rechts Tags hinzufügen.`,
'se35cf4c4d709a423': `erzeugt um`,
'se7bee6e9a9b5394c': `Privat`,
'sea4f08110bb8f15d': `Entfernen`,
'sf0cab2483f66aa2e': `Benutzerdefiniert`,
'sf982ec34a2d95a8d': `Geben Sie einen kurzen Überblick über den Inhalt der Materialien, die behandelten Themen und die angestrebte Diskussionstiefe`,
'sf9aee319a006c9b4': `Hinzufügen`,
'sfc5fc98b4dd794bc': str`${0} hat einen Diskussionsthread in ${1} geteilt`,
'sfe6d58ee4dafc5f0': `Bitte geben Sie einen Titel an, unter dem Studierende Ihre Materialien finden können.`,
    };
  